// extracted by mini-css-extract-plugin
module.exports = {"incompleteImg":"styles_incompleteImg__mNvHx","dialogPaper":"styles_dialogPaper__12uHN","finishButton":"styles_finishButton__2sIZF"};